<div class="flex w-full flex-col gap-1">
  @if (!readonly()) {
    @if (label()) {
      <label class="text-sm font-medium text-default" [attr.for]="inputId() || null">{{ label() }}</label>
    }

    <z-date-picker
      class="w-full"
      [attr.id]="inputId() || null"
      [value]="calendarValue"
      [minDate]="minDate()"
      [maxDate]="maxDate()"
      [disabled]="disabled()"
      [placeholder]="placeholderText()"
      [zFormat]="format()"
      [zAppearance]="fieldAppearance()"
      (dateChange)="onDateSelected($event)"
    ></z-date-picker>

    @if (showValidation()) {
      <svz-validation-message [control]="control"></svz-validation-message>
    }
  } @else {
    <div class="flex flex-col">
      @if (label()) {
        <span class="text-sm font-medium text-default">{{ label() }}</span>
      }
      <span class="text-base font-medium text-default">
        {{ readonlyText }}
      </span>
    </div>
  }
</div>
